<script>
	import { page } from '$app/stores';
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import { formatDate } from '$lib/utils';
	import { Link, SquareArrowOutUpRight } from 'lucide-svelte';
	import { toast } from 'svelte-sonner';
	import * as Breadcrumb from '$lib/components/ui/breadcrumb';
	import CTA from '$lib/components/layout/cta.svelte';
	import Hero from '$lib/components/layout/hero.svelte';

	export let data;

	function copy() {
		navigator.clipboard.writeText($page.url.href);
		toast.success('Link copied to clipboard');
	}
</script>

<svelte:head>
	<title>{data.metadata.title}</title>
	<meta property="og:type" content="article" />
	<meta property="og:title" content={data.metadata.title} />
</svelte:head>

<div class="cnt cnt-y-md">
	<Hero rating={false}>
		<div slot="title">{data.metadata.title}</div>

		<div slot="content">
			<span>{data.metadata.description}</span>

			<div class="flex flex-row items-center text-sm font-medium gap-3 mt-4">
				<div>
					{data.metadata.reading_time} min read · Published at {formatDate(data.metadata.date)}
				</div>

				<DropdownMenu.Root>
					<DropdownMenu.Trigger>
						<SquareArrowOutUpRight size={20} strokeWidth={1.2} absoluteStrokeWidth />
					</DropdownMenu.Trigger>
					<DropdownMenu.Content>
						<DropdownMenu.Group>
							<DropdownMenu.Label>
								<div>Share Options</div>
								<div class="text-xs font-light max-w-32">
									Share this post with your friends and family
								</div>
							</DropdownMenu.Label>
							<DropdownMenu.Separator />
							<DropdownMenu.Item on:click={copy}>
								<Link size={13} strokeWidth={2} class="mr-2" />Copy Link
							</DropdownMenu.Item>
						</DropdownMenu.Group>
					</DropdownMenu.Content>
				</DropdownMenu.Root>
			</div>
		</div>
	</Hero>
</div>

<hr />

<Breadcrumb.Root class="cnt cnt-y-xs">
	<Breadcrumb.List>
		<Breadcrumb.Item>
			<Breadcrumb.Link href="/">Home</Breadcrumb.Link>
		</Breadcrumb.Item>
		<Breadcrumb.Separator />
		<Breadcrumb.Item>
			<Breadcrumb.Link href="/blog">Blog</Breadcrumb.Link>
		</Breadcrumb.Item>
		<Breadcrumb.Separator />
		<Breadcrumb.Item>
			<Breadcrumb.Page>{data.metadata.title}</Breadcrumb.Page>
		</Breadcrumb.Item>
	</Breadcrumb.List>
</Breadcrumb.Root>

<hr />

<div class="cnt cnt-y-md">
	<article>
		<div class="my-8">
			<svelte:component this={data.content} />
		</div>

		<div>
			<div class="tags flex flex-row gap-2">
				{#each data.metadata.categories as category}
					<span class="bg-neutral-200 px-2.5 py-1 rounded-full text-sm font-light">{category}</span>
				{/each}
			</div>
		</div>
	</article>
</div>

<CTA />
